import { OPTIONS } from '@api/react-query/config'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { deleteAuthPerson, getAuthPersonInfo } from './endpoints'

enum queryKeys {
  GET_AUTH_PERSON_INFO = 'getAuthPersonInfo',
  DELETE_AUTH_PERSON = 'deleteAuthPerson',
}

export const useAuthPersonInfo = (authPersonId?: string) =>
  useQuery({
    queryKey: [queryKeys.GET_AUTH_PERSON_INFO, authPersonId],
    queryFn: () => getAuthPersonInfo(authPersonId as string),
    ...OPTIONS,
    enabled: Boolean(authPersonId),
  })

export const useDeleteAuthPerson = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: [queryKeys.DELETE_AUTH_PERSON],
    mutationFn: (authPersonId: string) => deleteAuthPerson(authPersonId),
    onSuccess: (_data, authPersonId) => {
      queryClient.removeQueries({ queryKey: [queryKeys.GET_AUTH_PERSON_INFO, authPersonId] })
    },
  })
}
